<template>
  <div class="terms-and-conditions">
    <v-container>
      <h2 class="text-center earth-color">Terms and Conditions</h2>
      <v-card class="terms-card">
        <v-container>
          <div class="content" v-html="singlePage.description">
            <p>I fully accept that by my entry into the Ol Pejeta Conservancy ("the conservancy") for any purposes whatsoever there exists inherent danger to my life and property. I confirm that I have read the conservancy's "code of conduct" and that I shall abide by it in order to be reasonably safe.</p>

            <p>I fully understand and accept that there are dangerous wild animals (including lions, rhinos, elephants, buffaloes, snakes, insects and others) within the conservancy and I accept that by entering into the conservancy for any purposes whatsoever, I agree to waive and release the conservancy, the Ol Pejeta Conservancy Limited and any of its employees, agents, affiliates and officers and to hold each of them harmless from all and any injury, liability, claim, accident, loss or damage of any nature that may arise as a result of my entry onto the conservancy including but not limited to personal injury (fatal or otherwise) and/or that may be caused to my personal property.</p>

            <p>This waiver is entered into on my behalf and on behalf of any minors accompanying me, and is binding on my assigns, heirs and legal representatives. If any portion of this waiver is unenforceable, such portion shall be struck out provided that the remaining portion shall remain in full force and effect. This waiver shall be governed by Kenyan laws.</p>

            <p class="highlight">By clicking submit you are agreeing to our terms and conditions, do you want to proceed?</p>
          </div>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: 'TermsAndConditions',
    props: {
      singlePage: {
        type: Object,
        default: () => ({
          description: ''
        })
      }
    }
  }
</script>

<style scoped>
  .terms-and-conditions {
    font-family: 'Arial', sans-serif;
    background-color: #f5f5f5;
    min-height: 100vh;
    padding: 20px 0;
  }

  .earth-color {
    color: #587e27;
    font-size: 2rem;
    margin-bottom: 20px;
    font-weight: 600;
  }

  .terms-card {
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .content {
    font-size: 1rem;
    line-height: 1.8;
    color: #333;
  }

    .content > > > p {
      margin-bottom: 1em;
    }

  .highlight {
    font-weight: bold;
    color: #d32f2f;
  }

  /* Responsive adjustments */
  @media (max-width: 768px) {
    .earth-color {
      font-size: 1.5rem;
    }

    .content {
      font-size: 0.9rem;
    }
  }

  .text-center {
    text-align: center;
  }
</style>

<!--<script>
export default {
  name: 'front-terms-and-conditions',
  data () {
    return {}
  },
  created () {
    this.$store.dispatch('get_page', 't&c')
  }
}
</script>-->

<style scoped>
</style>
